var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12","xs":"12"}},[_c('TableSupport',{ref:"table",attrs:{"show-title":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }